/* ============================================
   LOGOTEKA THEME - MAIN JS
============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // Mobile Nav Toggle
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
  const mnClose = document.querySelector('.mn-close');

  function openMobileNav() {
    if (mobileNav) mobileNav.classList.add('open');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('open');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileNav);
  if (mnClose) mnClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  // Cart Drawer Toggle
  const cartBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');

  cartBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (cartDrawer) cartDrawer.classList.toggle('open');
    });
  });

  // Add to Cart - AJAX
  const addBtns = document.querySelectorAll('[data-add-to-cart]');
  addBtns.forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      const originalText = btn.innerHTML;
      btn.innerHTML = '...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (response.ok) {
          updateCartCount();
          btn.innerHTML = '✓';
          setTimeout(() => { btn.innerHTML = originalText; btn.disabled = false; }, 1500);
        } else {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }
      } catch (err) {
        console.error('Cart error:', err);
        btn.innerHTML = originalText;
        btn.disabled = false;
      }
    });
  });

  // Update cart count badges
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      document.querySelectorAll('.cart-count, .sticky-cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (err) {
      console.error('Failed to update cart:', err);
    }
  }

  // Initial cart count
  updateCartCount();

  // Tab switching for collection age tabs
  window.switchAgeTab = function(btn, panelId) {
    const tabs = document.querySelectorAll('.age-tab');
    const panels = document.querySelectorAll('.age-panel');

    tabs.forEach(t => t.classList.remove('active'));
    btn.classList.add('active');

    panels.forEach(p => p.classList.remove('active'));
    const target = document.getElementById(panelId);
    if (target) target.classList.add('active');

    // Update sticky CTA if data attribute present
    const cta = btn.dataset.stickyCta;
    if (cta) {
      const stickyMain = document.querySelector('.sticky-main-btn .sticky-cta-text');
      if (stickyMain) stickyMain.textContent = cta;
    }
  };

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(item => {
    item.querySelector('.faq-q')?.addEventListener('click', function() {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => {
        if (el !== item) el.classList.remove('open');
      });
      item.classList.toggle('open');
    });
  });

  // Newsletter form
  document.querySelectorAll('.newsletter-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      // Shopify handles via /contact#contact_form action - no JS intercept needed
      // But could add validation here
    });
  });

});
